export default __webpack_public_path__ + "static/media/Roger Avanzi – in memorian_.0399eb5c.png";